// src/services/usageService.js
import { getAuthApiToken } from '../api/tokenService';

const AUTH_URL = process.env.REACT_APP_AUTH_URL; // || 'http://127.0.0.1:3000'

export const checkUsageLimit = async (featureType) => {
    try {
        const token = await getAuthApiToken();
        const response = await fetch(`${AUTH_URL}/api/auth/subscription/usage?feature=${featureType}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (response.ok) {
            return await response.json();
        }
        return { allowed: true, limit: 50, currentUsage: 0, remaining: 50 };
    } catch (error) {
        console.error('Error checking usage:', error);
        return { allowed: true, limit: 50, currentUsage: 0, remaining: 50 };
    }
};

export const trackUsage = async (featureType, increment = 1) => {
    try {
        const token = await getAuthApiToken();
        await fetch(`${AUTH_URL}/api/auth/subscription/track-usage`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ featureType, increment })
        });
    } catch (error) {
        console.error('Error tracking usage:', error);
    }
};

export const checkSubscriptionStatus = async () => {
    try {
        const token = await getAuthApiToken();
        const response = await fetch(`${AUTH_URL}/api/auth/subscription/my-subscription`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (response.ok) {
            return await response.json();
        }
        return null;
    } catch (error) {
        console.error('Error checking subscription:', error);
        return null;
    }
};